import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Typography, Paper, Chip, Stack, Box } from "@mui/material";

function NoteCard({ note }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 2 }}>
      <Link
        to={`/notes/${note.id}`}
        style={{ textDecoration: "none", color: "inherit", display: "block" }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: 2,
            borderRadius: 2,
            backgroundColor: theme.palette.background.card,
            border: `1px solid ${theme.palette.divider}`,
            transition: "border-color 0.2s ease",
            "&:hover": {
              borderColor: theme.palette.text.secondary
            }
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {note.title}
          </Typography>

          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            {note.category}
          </Typography>

          {note.tags && (
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              {note.tags.map(tag => (
                <Chip
                  key={tag}
                  label={tag}
                  size="small"
                  sx={{ backgroundColor: theme.palette.action.hover }}
                />
              ))}
            </Stack>
          )}
        </Paper>
      </Link>
    </Box>
  );
}

export default NoteCard;
